import { trackMixPanel as trackMixPanelAction, peopleincrement } from 'common-actions';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { MixpanelAction } from 'types/mixpanel';

export const useMixpanel = () => {
  const dispatch = useDispatch();

  const track = useCallback(
    (actionObject: any) => dispatch(trackMixPanelAction(actionObject)),
    [dispatch]
  );

  const getBrowserInfo = () => {
    const browser = navigator.userAgent;
    const os = navigator.platform;
    let device = 'unknown';

    if (/mobile/i.test(navigator.userAgent)) {
      device = 'Mobile';
    } else if (/tablet/i.test(navigator.userAgent)) {
      device = 'Tablet';
    } else {
      device = 'Desktop';
    }

    return { browser, os, device };
  };

  const addAdditionalData = (action: MixpanelAction) => {
    const { browser, os, device } = getBrowserInfo();

    // const browser = navigator.userAgent;
    // const os = navigator.platform;
    // const device = navigator.userAgentData ? navigator.userAgentData.platform : 'unknown';
    const finalAction = {
      ...action,
      Browser: browser,
      Device: device,
      OS: os
    };

    return finalAction;
  };

  const logToMixpanel = (action: MixpanelAction) => {
    const finalAction = addAdditionalData(action);
    track({
      ...finalAction
    });
  };

  const logToMixpanelMultiple = (actions: MixpanelAction[]) => {
    const finalActions = actions.map(addAdditionalData);
    track(finalActions);
  };

  const incrementPeople = (incrementName: string, number = 1) => {
    const data = {
      incrementName,
      number
    };
    try {
      dispatch(peopleincrement(data));
    } catch {
      /* empty */
    }
  };

  return {
    logToMixpanel,
    logToMixpanelMultiple,
    incrementPeople
  };
};
